export default __webpack_public_path__ + "static/media/rblogo.7392e3d0.png";